import { UntypedFormControl, ValidationErrors } from '@angular/forms';

export function phoneNumberValidator(
  control: UntypedFormControl
): ValidationErrors | null {
  const value = control.value;
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const normalizedValue = value?.toString().replace(/\D/g, '');

  return !normalizedValue.match(/^\d{10}$/)
    ? {
        invalidPhoneNumber: true,
      }
    : null;
}
